import { IBlockImage } from 'common/builder/blocks/blockInterfaces'
import { FlowChartImagePreview } from 'common/builder/components/chart/FlowChart/types/FlowChartImagePreview'

export class PreviewConverter {
  /**
   * There can be 2 cases when we can extract FlowChartImagePreview from IBlockImage:
   *
   * IUploadedImage - uploaded image, it has img_big + image_size
   *
   * IUploadFile - blob file that we have while it is being uploaded,
   * it can have preview but hasn't image_size
   */
  static fromIBlockImage(image: IBlockImage): FlowChartImagePreview | null {
    if (!image || typeof image !== 'object') {
      return null
    }

    const preview = 'preview' in image && image?.preview
    const imgBig = 'img_big' in image && image?.img_big
    const url = preview || imgBig

    if (!url) {
      return null
    }

    const size = image.image_size
      ? {
          width: image.image_size.width,
          height: image.image_size.height,
        }
      : null

    return {
      url,
      size,
    }
  }
}
